import { ApiClient } from '../../../../api/ApiClient';
import { FetchParameters } from '../../../../api/types';
import { getMultiTenancyHeaders } from '../../../../utils/multiTenancyHeaders';

export class UnifiedApiClient extends ApiClient {
  protected static get requestHeaders(): Record<string, string> {
    return {
      ...super.requestHeaders,
      ...getMultiTenancyHeaders(),
    };
  }

  static override async _fetch<T>({ body, ...params }: FetchParameters) {
    return await super._fetch<T>({
      body: {
        entityId: `JB${window.Jbhifi.storeLocation}`,
        ...body,
      },
      ...params,
    });
  }
  static async _fetchWithoutEntityId<T>({ body, ...params }: FetchParameters) {
    return await super._fetch<T>({
      body,
      ...params,
    });
  }
}
